import React, { FC } from 'react';
import Container from 'saur_ui_library/src/Atoms/Container/Container';
import Word from 'saur_ui_library/src/Atoms/Word/Word';
import RainIcon from 'saur_ui_library/src/Icons/RainIcon';
import ModalFlexible from 'saur_ui_library/src/Organisms/ModalFlexible/ModalFlexible';
import { createGlobalStyle } from 'styled-components';

type ErrorProps = {
  IsVisible: boolean;
  title: string;
  message: string;
};

const ErrorParameter: FC<ErrorProps> = (props) => {
  const [modalVisible, setModalVisible] = React.useState(props.IsVisible);
  return (
    <Container className='errorContainer sds-reset-style'>
      <Styles />
      <ModalFlexible
        className='error-modal'
        showHeader
        title={props.title}
        toggleModal={() => {
          setModalVisible(!props.IsVisible);
        }}
        visible={modalVisible}
        desktopContent={() => (
          <Container
            className='contentContainer'
            style={{ width: 550, height: 50 }}
          >
            <RainIcon />
            <Word
              className='errorMessage'
              variant='p'
              textStyle='normalReg'
              value={props.message}
            />
          </Container>
        )}
      />
    </Container>
  );
};
const Styles = createGlobalStyle`
.errorContainer.sds-reset-style{
  z-index:200;
  .modal-flex-desktop .modal-flex-desktop-overlay .modal-flex-desktop-position {
    height: 200px;
  }
  .contentContainer{

margin-left: auto;
margin-right: auto;  
}
.errorMessage{
margin-left: auto;
margin-right: auto; 
}
}

`;
export default ErrorParameter;
